// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appearance {
  position: relative;
}

.appearance-trigger {
  width: 38px;
  height: 38px;
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  background: var(--glass-bg);
  color: var(--color-white);
  font-size: 1.1rem;
  cursor: pointer;
  transition: background var(--transition-fast);
}

.appearance-trigger:hover {
  background: var(--glass-bg-strong);
}

.appearance-popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 264px;
  padding: var(--space-md);
  background: var(--color-dark-lighter);
  border: 1px solid var(--glass-border-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  z-index: var(--z-popover);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  animation: fadeIn var(--transition-fast);
}

/* Mobile: the trigger sits near the left of the TopBar, so anchoring the
   popover to right:0 would push it off the left edge of the viewport. Pin it
   to the viewport with insets instead so it stays fully on-screen. */
@media (max-width: 768px) {
  .appearance-popover {
    position: fixed;
    top: 60px;
    left: var(--space-md);
    right: var(--space-md);
    width: auto;
    max-height: calc(100vh - 76px);
    overflow-y: auto;
  }
}

.appearance-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.appearance-heading {
  font-size: var(--font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.6;
  color: var(--color-white);
}

.appearance-themes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-sm);
}

.appearance-theme {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: 6px 8px;
  background: var(--glass-bg);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-white);
  cursor: pointer;
  /* Let the button shrink inside its grid track instead of overflowing it. */
  min-width: 0;
  transition: border-color var(--transition-fast), background var(--transition-fast);
}

.appearance-theme:hover {
  background: var(--glass-bg-strong);
}

.appearance-theme.is-selected {
  border-color: var(--color-primary);
  background: var(--glass-bg-strong);
}

.appearance-swatch {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid var(--glass-border-strong);
  flex-shrink: 0;
}

.appearance-theme-name {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  /* min-width:0 lets the flex item shrink instead of forcing the button wider
     than its grid track; wrapping keeps long names readable rather than clipped. */
  min-width: 0;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-break: break-word;
  text-align: left;
}

.appearance-segment {
  display: flex;
  gap: var(--space-xs);
}

.appearance-seg-btn {
  flex: 1 1;
  padding: 8px 10px;
  background: var(--glass-bg);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-white);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: border-color var(--transition-fast), background var(--transition-fast);
}

.appearance-seg-btn:hover {
  background: var(--glass-bg-strong);
}

.appearance-seg-btn.is-selected {
  border-color: var(--color-primary);
  background: var(--gradient-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/AppearanceMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,qCAAqC;EACrC,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;;qEAEqE;AACrE;EACE;IACE,eAAe;IACf,SAAS;IACT,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,2EAA2E;EAC3E,YAAY;EACZ,kFAAkF;AACpF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC;mFACiF;EACjF,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC","sourcesContent":[".appearance {\n  position: relative;\n}\n\n.appearance-trigger {\n  width: 38px;\n  height: 38px;\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  background: var(--glass-bg);\n  color: var(--color-white);\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n\n.appearance-trigger:hover {\n  background: var(--glass-bg-strong);\n}\n\n.appearance-popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 264px;\n  padding: var(--space-md);\n  background: var(--color-dark-lighter);\n  border: 1px solid var(--glass-border-strong);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  z-index: var(--z-popover);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  animation: fadeIn var(--transition-fast);\n}\n\n/* Mobile: the trigger sits near the left of the TopBar, so anchoring the\n   popover to right:0 would push it off the left edge of the viewport. Pin it\n   to the viewport with insets instead so it stays fully on-screen. */\n@media (max-width: 768px) {\n  .appearance-popover {\n    position: fixed;\n    top: 60px;\n    left: var(--space-md);\n    right: var(--space-md);\n    width: auto;\n    max-height: calc(100vh - 76px);\n    overflow-y: auto;\n  }\n}\n\n.appearance-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.appearance-heading {\n  font-size: var(--font-size-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  opacity: 0.6;\n  color: var(--color-white);\n}\n\n.appearance-themes {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-sm);\n}\n\n.appearance-theme {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: 6px 8px;\n  background: var(--glass-bg);\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  color: var(--color-white);\n  cursor: pointer;\n  /* Let the button shrink inside its grid track instead of overflowing it. */\n  min-width: 0;\n  transition: border-color var(--transition-fast), background var(--transition-fast);\n}\n\n.appearance-theme:hover {\n  background: var(--glass-bg-strong);\n}\n\n.appearance-theme.is-selected {\n  border-color: var(--color-primary);\n  background: var(--glass-bg-strong);\n}\n\n.appearance-swatch {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1px solid var(--glass-border-strong);\n  flex-shrink: 0;\n}\n\n.appearance-theme-name {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  /* min-width:0 lets the flex item shrink instead of forcing the button wider\n     than its grid track; wrapping keeps long names readable rather than clipped. */\n  min-width: 0;\n  line-height: 1.2;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  text-align: left;\n}\n\n.appearance-segment {\n  display: flex;\n  gap: var(--space-xs);\n}\n\n.appearance-seg-btn {\n  flex: 1;\n  padding: 8px 10px;\n  background: var(--glass-bg);\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  color: var(--color-white);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: border-color var(--transition-fast), background var(--transition-fast);\n}\n\n.appearance-seg-btn:hover {\n  background: var(--glass-bg-strong);\n}\n\n.appearance-seg-btn.is-selected {\n  border-color: var(--color-primary);\n  background: var(--gradient-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
